import React from "react";
import "../../../components/filter/FilterGroupNew.js";
import "moment-timezone";
import "../../../components/input/validation.js";
import "../../../components/input/DatePicker.js";
import "../../../components/input/DateRangePicker.js";
import "../../../components/input/StyledInput.js";
import "../../../components/input/FormInput.js";
import "../../../components/input/StyledFormInputHoc.js";
import { getMirrorObject } from "../../../utils/object.js";
import "react-intl";
import "../../../components/input/DateSinglePicker.localize.js";
import "../../../components/input/hooks.js";
import "@mui/material";
import "../../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../../components/filter/date-filter/DateFilter.js";
import "../../../components/filter/TextFilterWithDropdown.js";
import { withQueryFilter } from "../../../components/filter/QueryFilterHoc.js";
import "../../../components/filter/MultiStepFilterDrawer.js";
import "../../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import "../../../components/select/Select.js";
import "../../../components/filter/TextFilter.js";
import "../../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import "../../../components/filter/dateRangeFilter/localized.js";
import "../../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../../components/filter/MultiStepFilterApplyButton.js";
import "../../../components/filter/MultiStepFilterInput.js";
import "../../../components/filter/MultiStepFilterHoc.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/select/selectStyle.js";
import "../../../components/select/MultiSelectFooter.js";
import "../../../components/select/MultiSelect.js";
import "../../../components/select/MultiSelectItem.js";
import "../../../components/select/SelectArrowIcon.js";
import "../../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../../components/select/SingleSelect.js";
import "../../../components/select/MultiSelectWithExclude.js";
import "../../../components/select/MultiSelectTextCounterWithTooltip.js";
import "../../../components/filter/PhoneFilter.js";
import { TransactionFilters } from "./Filters.js";
function TransactionFiltersAdapter({ model, onChange, ...props }) {
  const clientTextKeyToServer = {
    uid_un_tid_em: "uid_un_tid_em",
    uid: "uid",
    username: "username",
    transactionId: "transactionId",
    withdrawalId: "withdrawalId",
    email: "email"
  };
  const serverTextKeyToClient = getMirrorObject(clientTextKeyToServer);
  const filterModel = {
    text: model?.text ? { ...model?.text, option: serverTextKeyToClient[model?.text?.option] } : null,
    types: model?.transactionTypes,
    paymentMethod: model?.paymentMethodName,
    amount: {
      from: model?.amountMin,
      to: model?.amountMax
    },
    status: getTransactionStatusFilterValue(
      model?.transactionStatus,
      model?.transactionStatusWithReason
    ),
    date: {
      from: model?.["startedTs.from"],
      to: model?.["startedTs.to"],
      isHistorical: model?.isHistorical,
      year: model?.transactionYear
    }
  };
  function handleChange(model2) {
    const statusFilterHasReasons = model2?.status?.some((s) => s?.reason);
    const result = {
      text: model2?.text ? { ...model2?.text, option: clientTextKeyToServer[model2?.text?.option] } : void 0,
      "startedTs.from": model2?.date?.from,
      "startedTs.to": model2?.date?.to,
      isHistorical: model2?.date?.isHistorical,
      transactionYear: model2?.date?.year,
      transactionStatus: !statusFilterHasReasons && model2?.status?.length ? model2?.status?.map((i) => i?.status) : void 0,
      transactionStatusWithReason: statusFilterHasReasons ? model2?.status : void 0,
      amountMin: model2?.amount?.from,
      amountMax: model2?.amount?.to,
      transactionTypes: model2?.types,
      paymentMethodName: model2?.paymentMethod
    };
    onChange(result);
  }
  function getTransactionStatusFilterValue(statuses, statusWithReasons) {
    const statusesValue = (statuses ?? [])?.map((s) => ({ status: s }));
    return [...statusesValue, ...statusWithReasons ?? []];
  }
  return /* @__PURE__ */ React.createElement(TransactionFilters, { model: filterModel, onChange: handleChange, ...props });
}
const TransactionQueryFilters = withQueryFilter(TransactionFiltersAdapter, {
  uid: ["uid"],
  uidUsernameTransactionIdEmail: ["uid_un_tid_em", "uid", "username", "transactionId", "email"]
});
export {
  TransactionQueryFilters
};
//# sourceMappingURL=QueryFilters.js.map
